export const environment = {
    production: true,
    apiUrl: "",
    apiVersion: "1.0",
    groupName: "Klasse",
    groupsName: "",
    buildingName: "Schulhaus",
    buildingsName: "Schulhäuser",
    categories: "",
    children: "Kinder",
    firebase: {
        apiKey: "AIzaSyCG7xGsMk4tpZ7qU13cA2C-N6U8nKSz1hA",
        authDomain: "schule-schoren-91rq6.firebaseapp.com",
        databaseURL: "https://schule-schoren-91rq6-default-rtdb.firebaseio.com",
        projectId: "schule-schoren-91rq6",
        storageBucket: "schule-schoren-91rq6.appspot.com",
        messagingSenderId: "327098218993",
        appId: "1:327098218993:web:88b11eb60d960db7852c50",
        measurementId: "G-X86KPPQXSN"
    }
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts